// 文件后缀
const isExcelFilePattern = /\.?(xls|xlsb|xlsm|xlsx|xlt|xltx)$/i
const isWordFilePattern = /\.?(doc|docx|docm|dot|dotm)$/i
const isPPTFilePattern = /\.?(ppt|pptx)$/i
const isPDFFilePattern = /\.?(pdf)$/i
const isAPKFilePattern = /\.?(apk)$/i
const isExtractableFilePattern = /\.?(gz|tar|rar|g?zip)$/i
const isCodeFilePattern = /\.?(js|html|py|css|jsx|java|php|bat)$/i
const isTxtFilePattern = /\.?(txt|conf)$/i
const isBTFilePattern = /\.?(torrent)$/i
const isImageFilePattern = /\.?(ai|cdr|dcx|dxf|eps|jpe|jpeg2000|jpe?g|gif|icon|bmp|emf|exif|flic|fpx|pcd|pcx|pic|psd|png|HEIC?|raw|rle|tiff?|jfif|tiffxif|tga|svg|ufo|wmf|webp)$/i
const isVideoFilePattern = /\.?(video|m3u8|m4s|3g2|3gp|3gp2|3gpp|aiff|amr|amv|asf|au|avi|bik|dat|divx|dvd|evo|f4v|flv|hlv|m1a|m1v|m2a|m2p|m2ts|m2v|m4b|m4p|m4r|m4v|mkv|mov|mp2|mp2v|mp4|mpa|mpc|mpe|mpeg|mpeg1|mpeg2|mpeg4|mpg|mpv2|mts|oga|ogm|ogv|ogx|pmp|pva|qt|ram|rm|rmvb|rpm|ts|vob|vp6|wm|wmp|wmv|wv|f5v|mp5)$/i
const isAudioFilePattern = /\.?(ape|wav|ogg|m4a|flac|aac|ac3|acc|dts|mid|mka|mp3|ra|wma)$/i
const isExeFilePattern = /\.?(exe|nes)$/i
const isSubtitleFilePattern = /\.?(pjs|smi|ssa|ass|srt)$/i
const isXmindFilePattern = /\.?(xmind|prc|json|csv|log|cfg|cnf|markdown|md|xml|tsv|ini)$/i
const isIPSWFilePattern = /\.?(ipsw)$/i
const isIPAFilePattern = /\.?(ipa)$/i
const isDMGFilePattern = /\.?(dmg)$/i
const isURLFilePattern = /\.?(url)$/i
const isM3U8FilePattern = /\.?(m3u8)$/i
const isDLLFIlePattern = /\.?(dll)$/i
const isPKGFilePattern = /\.?(pkg)$/i
const isGIFFilePattern = /\.?(gif)$/i
const isISOFilePattern = /\.?(iso)$/i
const isMOBIFilePattern =  /\.?(mobi)$/i
const isEPUBFilePattern =  /\.?(mpub)$/i
const isCHMFilePattern = /\.?(chm)$/i
const isKeyFilePattern = /\.?(key)$/i
const isPagesFilePattern = /\.?(pages)$/i
const isNumbersFilePattern = /\.?(numbers)$/i
// 文件图标
const APKFileIcon = 'https://backstage-img-ssl.a.88cdn.com/25d55f18d48e93ad8a33481497c4549713d999fc'
const ExcelFilIcon = 'https://backstage-img-ssl.a.88cdn.com/81b42539ba1265c757567eac60028d35b0a0c213'
const PPTFileIcon = 'https://backstage-img-ssl.a.88cdn.com/1890125a12f6ad21e38cff67fbb39905a82126bd'
const PDFFileIcon = 'https://backstage-img-ssl.a.88cdn.com/41b70d6ba221c563ae01bd05d9288586e46a462c'
const ImageFileIcon = 'https://backstage-img-ssl.a.88cdn.com/9a6e1510e6ec2b667cc6af51d385c87da2ea7273'
const ExtractableFileIcon = 'https://backstage-img-ssl.a.88cdn.com/9572b78d1ea935165c54186e6b2c12a3dd7748ba'
const TextFileIcon = 'https://backstage-img-ssl.a.88cdn.com/a98969c71373413ec3cb178ff13c5c699953a2aa'
const AudioFileIcon = 'https://backstage-img-ssl.a.88cdn.com/3b90d99ed1a6fb9dd61fa4a09d0ad8b73ede93ea'
const WordFileIcon = 'https://backstage-img-ssl.a.88cdn.com/16dce427602497764c12ee8fb929a929a631f5a2'
const ExeFileIcon = 'https://backstage-img-ssl.a.88cdn.com/a8ed2a67287edefd6d852dee8d8a668bab8a00b9'
const SubtitleFileIcon = 'https://backstage-img-ssl.a.88cdn.com/fe237eea21ae21f97418b2004ff2bebbc1afc87a'
const XmindFileIcon = 'https://backstage-img-ssl.a.88cdn.com/79659c6b876dc965e86caba1c5ebedcebf758f3f'
const IPSWFileIcon = 'https://backstage-img-ssl.a.88cdn.com/a7b62c68de864e789da5f21441abe343a8cdd985'
const IPAFileIcon = 'https://backstage-img-ssl.a.88cdn.com/04a6996e4cd9805ed3d5355d9a0995925d61f86e'
const DMGFileIcon = 'https://backstage-img-ssl.a.88cdn.com/4846498fdf97fa1c140d93804cb3d4a97f1b2cf0'
const URLFileIcon = 'https://backstage-img-ssl.a.88cdn.com/df27655fde60fe8c41d03af26f4938c094f3e633'
const CodeFileIcon = 'https://backstage-img-ssl.a.88cdn.com/a87a998e402accee93295d0f3a4b7630e1652c62'
const M3U8FileIcon = 'https://backstage-img-ssl.a.88cdn.com/9157e3d21d2b69388cfd183927e6c9f21c67422c'
const DLLFileIcon = 'https://backstage-img-ssl.a.88cdn.com/2dcb6c8310b25734d090adaceef88c368d507bf5'
const PKGFileIcon = 'https://backstage-img-ssl.a.88cdn.com/774dc29ddc397e6738f29fe6dfdd12a3149f79f4'
const GIFFileIcon = 'https://backstage-img-ssl.a.88cdn.com/444acd82ce4552b54ac19f950e084147e5b86ff5'
const ISOFileIcon = 'https://backstage-img-ssl.a.88cdn.com/444acd82ce4552b54ac19f950e084147e5b86ff5'
const MOBIFileIcon = 'https://backstage-img-ssl.a.88cdn.com/74f8b1f3b8b0a7245c102c63e8cd83d780700f84'
const EPUBFileIcon = 'https://backstage-img-ssl.a.88cdn.com/e3d4168e3192c6f01f4025d6a19d92a7ed2015f6'
const CHMFileIcon = 'https://backstage-img-ssl.a.88cdn.com/70fb4de4a6f1f44a03bedc02abca527235191387'
const KeyFileIcon = 'https://backstage-img-ssl.a.88cdn.com/55c9d0b5fbcb1fefef5ed93ea3b382e4bb264301'
const PagesFileIcon = 'https://backstage-img-ssl.a.88cdn.com/e1dd0c8f1aa22cfabe961d0f82c897a155f369fd'
const NumbersFileIcon = 'https://backstage-img-ssl.a.88cdn.com/ab2ed9ca8a87c23382bbf198209c9b6935c8bf12'

export const TorrentIcon = 'https://backstage-img-ssl.a.88cdn.com/73b335abdf5ed57f53f93e428cc7983a09426f03'
export const UnknownIcon = 'https://backstage-img-ssl.a.88cdn.com/f690c22cc5b531002b273ad23e33a8d532508094'
export const FileIcon = 'https://backstage-img-ssl.a.88cdn.com/79659c6b876dc965e86caba1c5ebedcebf758f3f'
export const FloderIcon = 'https://backstage-img-ssl.a.88cdn.com/36de21fd06b9ebdd5092b68652b6fc6118e23c2b'
export const BTFloderIcon = 'https://backstage-img-ssl.a.88cdn.com/67f0b3d24a0fffaa5315190169482d3757d9a28b'
export const DefaultDownloadDirIcon = 'https://backstage-img-ssl.a.88cdn.com/d608d31529f420396cb45922dd40e1265ae1fdf0'
export const LinkIcon = 'https://oss-nas-ssl.xunlei.com/hezi/images/static/web/link.png'
export const VideoFileIcon = 'https://backstage-img-ssl.a.88cdn.com/1ed91f50c72024844a2940f7c358c80de960810e'

function isAudioFile (filename: string) {
  return isAudioFilePattern.test(filename)
}
function isVideoFile (filename: string) {
  return isVideoFilePattern.test(filename)
}
function isImageFile (filename: string) {
  return isImageFilePattern.test(filename)
}
function isExcelFile (filename: string) {
  return isExcelFilePattern.test(filename)
}
function isWordFile (filename: string) {
  return isWordFilePattern.test(filename)
}
function isPPTFile (filename: string) {
  return isPPTFilePattern.test(filename)
}
function isPDFFile (filename: string) {
  return isPDFFilePattern.test(filename)
}
function isAPKFile (filename: string) {
  return isAPKFilePattern.test(filename)
}
function isExtractableFile (filename: string) {
  return isExtractableFilePattern.test(filename)
}
function isCodeFile (filename: string) {
  return isCodeFilePattern.test(filename)
}
function isTextFile (filename: string) {
  return isTxtFilePattern.test(filename)
}
function isTorrent (filename: string) {
  return isBTFilePattern.test(filename)
}

function isExe (filename: string) {
  return isExeFilePattern.test(filename)
}


function getFileExtFormat (filename: string) {
  const [ext = ''] = filename.includes('.') ? filename.split('.').slice(-1) : ['']
  return ext
}

function getFileIconUrl (filename = '') {
  const ext = getFileExtFormat(filename)
  if (isAPKFile(ext)) {
    return APKFileIcon
  }
  if (isExcelFile(ext)) {
    return ExcelFilIcon
  }
  if (isPDFFile(ext)) {
    return PDFFileIcon
  }
  if (isPPTFile(ext)) {
    return PPTFileIcon
  }
  if (isGIFFilePattern.test(ext)) {
    return GIFFileIcon
  }
  if (isImageFile(ext)) {
    return ImageFileIcon
  }
  if (isExtractableFile(ext)) {
    return ExtractableFileIcon
  }
  if (isTextFile(ext)) {
    return TextFileIcon
  }
  if (isAudioFile(ext)) {
    return AudioFileIcon
  }
  if (isM3U8FilePattern.test(ext)) {
    return M3U8FileIcon
  }
  if (isVideoFile(ext)) {
    return VideoFileIcon
  }
  if (isWordFile(ext)) {
    return WordFileIcon
  }
  if (isTorrent(ext)) {
    return TorrentIcon
  }
  if (isExe(ext)) {
    return ExeFileIcon
  }
  if (isSubtitleFilePattern.test(ext)) {
    return SubtitleFileIcon
  }
  if (isXmindFilePattern.test(ext)) {
    return XmindFileIcon
  }
  if (isIPSWFilePattern.test(ext)) {
    return IPSWFileIcon
  }
  if (isIPAFilePattern.test(ext)) {
    return IPAFileIcon
  }
  if (isDMGFilePattern.test(ext)) {
    return DMGFileIcon
  }
  if (isURLFilePattern.test(ext)) {
    return URLFileIcon
  }
  if (isCodeFilePattern.test(ext)) {
    return CodeFileIcon
  }
  if (isDLLFIlePattern.test(ext)) {
    return DLLFileIcon
  }
  if (isPKGFilePattern.test(ext)) {
    return PKGFileIcon
  }
  if (isISOFilePattern.test(ext)) {
    return ISOFileIcon
  }

  if (isMOBIFilePattern.test(ext)) {
    return MOBIFileIcon
  }
  if (isEPUBFilePattern.test(ext)) {
    return EPUBFileIcon
  }
  if (isCHMFilePattern.test(ext)) {
    return CHMFileIcon
  }
  if (isKeyFilePattern.test(ext)) {
    return KeyFileIcon
  }
  if (isPagesFilePattern.test(ext)) {
    return PagesFileIcon
  }

  if (isNumbersFilePattern.test(ext)) {
    return NumbersFileIcon
  }

  // if (ext) return UnknownIcon
  return UnknownIcon
}

function submitDownloadFileToBroswer (href: string, fileName: string) {
  const a = document.createElement('a')
  a.href = href
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

const pathJoin = (...arg: unknown[]) =>
  ('/' + arg.flat().join('/'))
    .replace(/(\/)+/gm, '/')
    .replace(/^(\w).+/, (p) => `/${p}`)
    .replace(/(\/)$/, '')

// const joinPath = (...arg: unknown[]) =>
//   ('/' + arg.flat(Infinity).join('/'))
//     .replace(/(\/)+/gm, '/')
//     .replace(/^(\w).+/, (p) => `/${p}`)

const normalizeDiskPath = (...arg: unknown[]) => {
  const prefix = '/xos_storage/v1'
  return pathJoin(prefix, arg)
}

const escapeRegex = (str:string):string => {
  return str.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')
}

export {
  isAudioFile,
  isVideoFile,
  isImageFile,
  isExcelFile,
  isWordFile,
  isPDFFile,
  isPPTFile,
  isAPKFile,
  isTextFile,
  isCodeFile,
  isExtractableFile,
  isTorrent,
  getFileExtFormat,
  getFileIconUrl,
  submitDownloadFileToBroswer,
  pathJoin,
  // joinPath,
  normalizeDiskPath,
  escapeRegex,
}